import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RootStore } from './root.store';

@Injectable()
export class RootService {
  constructor(private store: RootStore, private http: HttpClient) {}

  showLoader() {
    this.store.update((state) => ({
      loading: true,
      loaderCount: state.loaderCount + 1,
    }));
  }

  hideLoader() {
    this.store.update((state) => {
      const loaderCount = Math.max(state.loaderCount - 1, 0);
      return {
        loaderCount,
        loading: loaderCount > 0,
      };
    });
  }

  hideAllLoaders() {
    this.store.update(() => ({
      loading: false,
      loaderCount: 0,
    }));
  }
}
